export const disablePastingNonNumbers = (e: any) => {
  const pasteData = e.clipboardData.getData('text/plain');
  if (pasteData.match(/[^0-9]/)) {
    e.preventDefault()
  }
}